import { notFoundSVGIcon } from './common';
import { getNumericObjectValues } from '../../../core/utils/general/general';

import {
  SVGIconDetail,
  SVGIconWithoutValue,
  createSVGCircle,
  createSVGEllipse,
  createSVGPath,
  createSVGRectangle,
} from './icons';
import { PathConfig } from 'konva/lib/shapes/Path';

const pendingPaymentInflowIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 1024,
  shapes: [
    createSVGPath(
      'M694.59 511.92c-121.21 0-219.47 98.26-219.47 219.47s98.26 219.47 219.47 219.47 219.47-98.26 219.47-219.47-98.26-219.47-219.47-219.47z m0 365.79c-80.69 0-146.33-65.64-146.33-146.33 0-80.69 65.64-146.33 146.33-146.33 80.68 0 146.33 65.64 146.33 146.33 0 80.69-65.65 146.33-146.33 146.33z'
    ),
    createSVGPath(
      'M200.01 814.55c-23.52-39.54-24.45-87.29-2.48-127.71L411.7 292.57h127.24l101.25 184.96 64.14-35.11-82.03-149.85h35.02v-73.14h-33.38l69.95-146.29H255.02l76.34 146.29H291.6v73.14h36.84l-195.2 359.34c-34.39 63.34-32.93 138.11 3.91 200.04s101.86 98.91 173.91 98.91h126.66v-73.14H311.06c-46.02-0.01-87.53-23.61-111.05-63.17z m175.68-668.26h202.14l-34.98 73.14H413.86l-38.17-73.14zM722.03 633.93h-54.86v112.66l89.87 89.09 38.61-38.97-73.62-72.98z'
    ),
  ],
});

const receivedCheckIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 32,
  shapes: [
    createSVGPath(
      'M 2 7 L 2 25 L 30 25 L 30 7 L 2 7 z M 4 9 L 28 9 L 28 23 L 4 23 L 4 9 z M 6 11 L 6 13 L 16 13 L 16 11 L 6 11 z M 20 11 L 20 16 L 26 16 L 26 11 L 20 11 z M 6 14 L 6 16 L 13 16 L 13 14 L 6 14 z M 8.5 17 C 7.895 17 7.4695 17.34425 7.1875 17.65625 C 6.9065 17.96925 6.69925 18.3165 6.53125 18.6875 C 6.19525 19.4345 6 20.238 6 21 L 8 21 C 8 20.68 8.156 19.984 8.375 19.5 C 8.437 19.359 8.5005 19.31175 8.5625 19.21875 C 8.6365 19.32075 8.69125 19.38625 8.78125 19.53125 C 8.92625 19.76525 9.08625 20.0475 9.28125 20.3125 C 9.47625 20.5785 9.71475 21.01525 10.46875 21.03125 C 11.06275 21.04325 11.2455 20.8285 11.4375 20.6875 C 11.6285 20.5465 11.76125 20.41425 11.90625 20.28125 C 12.00425 20.19125 12.08225 20.1255 12.15625 20.0625 C 12.18325 20.1015 12.294703 20.16725 12.845703 20.40625 C 13.512703 20.69825 14.523 21 16 21 L 16 19 C 14.77 19 14.12925 18.80075 13.65625 18.59375 C 13.18325 18.38675 12.824 18 12 18 C 11.398 18 11.2465 18.234 11.0625 18.375 C 10.8985 18.5 10.78525 18.633 10.65625 18.75 C 10.59725 18.656 10.57 18.609 10.5 18.5 C 10.332 18.227 10.13275 17.918 9.84375 17.625 C 9.55475 17.332 9.098 17 8.5 17 z M 20 19 L 20 21 L 26 21 L 26 19 L 20 19 z'
    ),
  ],
});

const receivedBankIconDetail = (): SVGIconWithoutValue => {
  const commonStyle: Partial<PathConfig> = {
    hasStroke: true,
    strokeWidth: 1.5,
    lineCap: 'round',
    lineJoin: 'round',
  };
  return {
    viewBoxSize: 24,
    shapes: [
      createSVGPath(
        'M12.37 2.15009L21.37 5.75006C21.72 5.89006 22 6.31006 22 6.68006V10.0001C22 10.5501 21.55 11.0001 21 11.0001H3C2.45 11.0001 2 10.5501 2 10.0001V6.68006C2 6.31006 2.28 5.89006 2.63 5.75006L11.63 2.15009C11.83 2.07009 12.17 2.07009 12.37 2.15009Z',
        commonStyle
      ),
      createSVGPath(
        'M22 22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19V22Z',
        commonStyle
      ),
      createSVGPath('M4 18V11', commonStyle),
      createSVGPath('M8 18V11', commonStyle),
      createSVGPath('M12 18V11', commonStyle),
      createSVGPath('M16 18V11', commonStyle),

      createSVGPath('M20 18V11', commonStyle),

      createSVGPath('M1 22H23', commonStyle),

      createSVGPath(
        'M12 8.5C12.8284 8.5 13.5 7.82843 13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5Z',
        { ...commonStyle, fillOpposite: true }
      ),
      // createSVGPath(
      //   'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z'
      // ),
    ],
  };
};

const receivedCashIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 392.533,
  shapes: [
    createSVGPath(
      'M65.422,175.293c0,12.024-9.762,21.786-21.786,21.786v102.594c12.024,0,21.786,9.762,21.786,21.786 h202.667c0-12.024,9.762-21.786,21.786-21.786V197.079c-12.024,0-21.786-9.762-21.786-21.786'
    ),
    createSVGPath(
      'M160.517,220.868h31.677c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925 h-9.762v-3.62c0-6.012-4.848-10.925-10.925-10.925c-6.012,0-10.925,4.848-10.925,10.925v3.62h-0.129 c-16.614,0-30.061,13.511-30.061,30.061c0,16.614,13.511,30.061,30.061,30.061h12.412c4.59,0,8.275,3.685,8.275,8.275 c0,4.59-3.685,8.275-8.275,8.275h-31.677c-6.012,0-10.925,4.849-10.925,10.925s4.848,10.925,10.925,10.925h19.329v3.685 c0,6.012,4.848,10.925,10.925,10.925c6.012,0,10.925-4.848,10.925-10.925v-5.236c11.96-3.943,20.622-15.192,20.622-28.509 c0-16.614-13.511-30.061-30.061-30.061h-12.412c-4.59,0-8.275-3.685-8.275-8.275C152.242,224.553,155.927,220.868,160.517,220.868z ',
      {
        fillOpposite: true,
      }
    ),
    createSVGPath(
      'M262.659,229.531c-6.012,0-10.925,4.848-10.925,10.925v15.903c0,6.012,4.848,10.925,10.925,10.925 c6.012,0,10.925-4.848,10.925-10.925v-15.903C273.519,234.38,268.671,229.531,262.659,229.531z',
      {
        fillOpposite: true,
      }
    ),
    createSVGPath(
      'M70.853,229.531c-6.012,0-10.925,4.848-10.925,10.925v15.903c0,6.012,4.848,10.925,10.925,10.925 s10.925-4.848,10.925-10.925v-15.903C81.778,234.38,76.865,229.531,70.853,229.531z',
      {
        fillOpposite: true,
      }
    ),
    createSVGPath(
      'M389.366,119.632l-85.592-85.527c-4.073-4.073-10.731-4.267-15.063-0.388l-33.939,30.901 l-73.115-33.293c-21.915-9.956-48.291-0.453-58.699,21.269l-38.141,79.192H33.358C14.998,131.786,0,146.784,0,165.143v166.659 c0,18.36,14.998,33.358,33.358,33.358h266.731c18.36,0,33.358-14.998,33.358-33.358V191.713l55.855-56.695 C393.632,130.751,393.568,123.899,389.366,119.632z M311.725,331.866c0,6.4-5.172,11.572-11.572,11.572H33.358 c-6.4,0-11.572-5.172-11.572-11.572V165.143c0-6.4,5.172-11.572,11.572-11.572H77.77c-0.517,13.446,6.077,26.57,18.36,33.939 c19.782,11.636,43.378,3.62,53.075-14.61l10.343-19.329h140.477c6.4,0,11.572,5.172,11.572,11.572v166.723H311.725z M171.378,131.786l5.107-9.438c2.65-3.62,5.818-4.073,9.503-1.422l10.925,10.796h-25.535V131.786z M333.188,161.006 c-2.069-16.485-16.097-29.22-33.099-29.22H227.62l-26.376-26.246c-13.446-12.735-34.521-10.537-44.154,6.594l-27.152,50.554 c-3.62,7.24-13.77,11.184-22.626,6.271c-7.176-4.331-9.891-13.382-6.271-20.945l41.438-85.851 c5.301-11.119,18.877-15.968,30.061-10.925l79.644,36.331c3.943,1.745,8.663,1.099,11.895-1.875l31.547-28.768l70.659,70.529 L333.188,161.006z'
    ),
  ],
});

const failedPaymentIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 32,
  shapes: [
    createSVGPath(
      'M19.587 16.001l6.096 6.096c0.396 0.396 0.396 1.039 0 1.435l-2.151 2.151c-0.396 0.396-1.038 0.396-1.435 0l-6.097-6.096-6.097 6.096c-0.396 0.396-1.038 0.396-1.434 0l-2.152-2.151c-0.396-0.396-0.396-1.038 0-1.435l6.097-6.096-6.097-6.097c-0.396-0.396-0.396-1.039 0-1.435l2.153-2.151c0.396-0.396 1.038-0.396 1.434 0l6.096 6.097 6.097-6.097c0.396-0.396 1.038-0.396 1.435 0l2.151 2.152c0.396 0.396 0.396 1.038 0 1.435l-6.096 6.096z'
    ),
  ],
});

const refundedPaymentIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 193.769,
  shapes: [
    createSVGPath(
      'M149.203,41.104l-9.348,12.009c20.15,15.679,30.201,41.063,26.234,66.253c-2.906,18.484-12.838,34.73-27.964,45.748 c-15.131,11.012-33.64,15.488-52.124,12.567c-38.157-6.008-64.32-41.938-58.322-80.098C30.585,79.097,40.52,62.85,55.648,51.835 c13.208-9.615,28.991-14.233,45.086-13.317L87.579,52.319l9.759,9.313l20.766-21.801l0.005,0.008l9.303-9.769l-9.752-9.303 l-0.005,0.003L95.862,0l-9.31,9.769l14.2,13.525c-19.303-0.913-38.21,4.702-54.059,16.242 C28.28,52.943,16.19,72.717,12.65,95.221c-7.302,46.445,24.54,90.184,70.985,97.493c4.489,0.708,8.976,1.055,13.434,1.055 c17.89,0,35.273-5.623,50.011-16.356c18.415-13.409,30.503-33.183,34.043-55.682C185.952,91.077,173.72,60.181,149.203,41.104z'
    ),
    createSVGPath(
      'M105.24,151.971v-0.003h0.001v-8.757c10.383-1.159,20.485-7.718,20.485-20.17c0-16.919-15.732-18.859-27.223-20.274 c-7.347-0.878-12.97-1.897-12.97-6.348c0-6.188,8.722-6.855,12.473-6.855c5.567,0,11.507,2.617,13.525,5.957l0.586,0.971 l11.542-5.341l-0.571-1.164c-4.301-8.793-12.009-11.337-17.85-12.364v-7.71H91.723v7.677 c-12.582,1.856-20.054,8.839-20.054,18.829c0,16.29,14.791,17.943,25.582,19.153c9.617,1.134,14.094,3.51,14.094,7.469 c0,7.563-10.474,8.154-13.685,8.154c-7.147,0-14.038-3.566-16.031-8.301l-0.495-1.169l-12.539,5.316l0.5,1.169 c3.713,8.691,11.725,14.137,22.63,15.425v8.336H105.24z'
    ),
  ],
});

export enum PaymentInflowStatus {
  Pending = 1,
  ReceivedBank = 2,
  ReceivedCheck = 4,
  ReceivedCash = 8,
  Failed = 16,
  Refunded = 32,
}

const getPaymentInflowIcon = (status: string | number) => {
  switch (status) {
    case PaymentInflowStatus.Pending:
      return pendingPaymentInflowIconDetail();
    case PaymentInflowStatus.ReceivedCheck:
      return receivedCheckIconDetail();
    case PaymentInflowStatus.ReceivedBank:
      return receivedBankIconDetail();
    case PaymentInflowStatus.ReceivedCash:
      return receivedCashIconDetail();
    case PaymentInflowStatus.Failed:
      return failedPaymentIconDetail();
    case PaymentInflowStatus.Refunded:
      return refundedPaymentIconDetail();
  }

  return notFoundSVGIcon();
};
export const getPaymentInflowIconSet = (): SVGIconDetail[] =>
  getNumericObjectValues(PaymentInflowStatus).map((value) => ({
    value,
    ...getPaymentInflowIcon(value),
  }));
